import styled from "styled-components";
import { device } from "../../styles/devices";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";


export const TestimonialsCardContainer = styled(Swiper)`
`;
export const CardItem = styled(SwiperSlide)`
    background-color: var(--color-white);
    border: 1px solid rgba(0,0,0 0.1);
    padding: 1.5rem 2rem;
    border-radius: 1.5rem;
    margin-bottom: 3rem;
    box-shadow: 0 1px 8px rgba(0,0,0,0.15);
    transition: background-color .3s;

    &:hover{
        background-color: var(--color-white-hover);
    }

    @media ${device.mobile}{
        padding: 1.5rem 1rem;
    }

    img{
        width: 80px;
        border-radius: 3rem;
        margin-bottom: 1rem;
    }

    h3{
        font-size: 1.1rem;
        font-weight: var(--font-medium);
        line-height: 1.6rem;
        color: var(--color-title);
        margin-bottom: .5rem;
    }

    p{
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: var(--font-normal);
        color: var(--color-text);
    }

`;